import { useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import axiosInstance from '../../../api/axios';
import { toastStyles } from '../../../styles/styles';

export const useConstitutionActions = (theme, handleOpenDeleteModal, setEditData) => {
    const [downloadingId, setDownloadingId] = useState(null);

    const handleEdit = useCallback((item) => {
        setEditData(item);
    }, [setEditData]);

    const handleDelete = useCallback((item) => {
        handleOpenDeleteModal(item);
        return item; // Return item to be used by the delete modal
    }, [handleOpenDeleteModal]);
  

    const handleDownload = useCallback(async (data) => {
        try {
            setDownloadingId(data.id);
            if (!data.manual?.uri) {
                toast.error('Entry has no content to download', { ...toastStyles, theme: theme });
                return;
            }
            
            const res = await axiosInstance.get(`/fsmanuals/${data.manual.uri}`, {
                responseType: 'blob',
                headers: {
                    'Cache-Control': 'no-cache',
                    Pragma: 'no-cache',
                    Expires: '0'
                }
            });

            // Create a blob URL for the file
            const fileBlob = new Blob([res.data], { type: res.data.type });
            const url = URL.createObjectURL(fileBlob);

            // Create a temporary link element and trigger download
            const link = document.createElement('a');
            link.href = url;
            link.download = data.title || 'document.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Clean up the blob URL
            URL.revokeObjectURL(url);

            toast.success('Download completed successfully', { ...toastStyles, theme: theme });
        } catch (error) {
            toast.error('Error downloading manual', { ...toastStyles, theme: theme });
        } finally {
            setDownloadingId(null);
        }
    }, [theme]);

    const truncateDescription = useCallback((description) => {
        return description.length > 50 ? description.substring(0, 50) + '...' : description;
    }, []);

    return {
        downloadingId,
        handleEdit,
        handleDelete,
        handleDownload,
        truncateDescription
    };
}; 